import { Colors, Services } from '@sigma-frontend-libs/commons'
import { DICTIONARIES, DICTIONARIES_STATUSES } from '@sigma-legacy-libs/essentials/lib/constants'

import { permissionPresets, request } from '@/utils'

import { dictionaryActions } from '@/components/services/dictionaries/utils'

import render from './render'

export default {
  name: 'Item',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  data() {
    return {
      total: undefined
    }
  },

  mounted() {
    this.getTotal()
  },

  computed: {
    label() {
      switch (this.value.type) {
        case DICTIONARIES['phone:mnp']:
        case DICTIONARIES['phone:ranges']: return this.getTranslate(`${Services.dictionaries}.labels.total`, { total: this.value.total })
        case DICTIONARIES['phone:opgroups']: {
          if (this.total !== undefined) {
            return this.getTranslate(`${Services.dictionaries}.labels.total`, { total: this.total })
          }

          return this.getTranslate('commons.labels.id')
        }
      }
    },

    loading() {
      return [ DICTIONARIES_STATUSES.compiling ].includes(this.value.status)
    },

    removeDisabled() {
      switch (this.value.type) {
        case DICTIONARIES['phone:mnp']:
        case DICTIONARIES['phone:ranges']: {
          return [
            DICTIONARIES_STATUSES.activated,
            DICTIONARIES_STATUSES.compiling
          ].includes(this.value.status)
        }
        case DICTIONARIES['phone:opgroups']: {
          return ![
            DICTIONARIES_STATUSES.ready,
            DICTIONARIES_STATUSES.compiled,
            DICTIONARIES_STATUSES.compileError
          ].includes(this.value.status)
        }
        default: return true
      }
    },

    actionProps() {
      let color
      let action
      switch (this.value.status) {
        case DICTIONARIES_STATUSES.ready: {
          color = Colors.primary
          action = dictionaryActions.compile
          break
        }
        case DICTIONARIES_STATUSES.compiled: {
          color = Colors.success
          action = dictionaryActions.set
          break
        }
        case DICTIONARIES_STATUSES.activated: {
          color = Colors.error
          action = dictionaryActions.unset
          break
        }
      }

      return {
        color,
        action
      }
    },

    canUpdateDictionariesAsAdmin() {
      return this.checkPermissions(`advanced.${Services.dictionaries}.update`)
    },
    canUpdateDictionariesAsResellerUp() {
      return this.checkPermissions(`advanced.${Services.dictionaries}.update`, permissionPresets.resellerUp)
    },
    canRemoveDictionariesAsResellerUp() {
      return this.checkPermissions(`advanced.${Services.dictionaries}.remove`, permissionPresets.resellerUp)
    },
    canGetOperatorGroupsAsResellerUp() {
      return this.checkPermissions(`advanced.${Services.operatorGroups}.get`, permissionPresets.resellerUp)
    },

    canUpdate() {
      switch (this.value.status) {
        case DICTIONARIES_STATUSES.ready:
        case DICTIONARIES_STATUSES.compiled: return this.canUpdateDictionariesAsResellerUp
        case DICTIONARIES_STATUSES.activated: return this.canUpdateDictionariesAsAdmin && this.value.OwnerId
      }
    },

    hasContent() {
      switch (this.value.type) {
        case DICTIONARIES['phone:mnp']:
        case DICTIONARIES['phone:ranges']: return [ DICTIONARIES_STATUSES.compiled, DICTIONARIES_STATUSES.activated ].includes(this.value.status)
        case DICTIONARIES['phone:opgroups']: return [ DICTIONARIES_STATUSES.compiled, DICTIONARIES_STATUSES.activated ].includes(this.value.status)
        default: return false
      }
    }
  },

  methods: {
    async getTotal() {
      if (this.value.type !== DICTIONARIES['phone:opgroups']) {
        return
      }
      if (!this.canGetOperatorGroupsAsResellerUp) {
        return
      }

      try {
        const data = await request.find(Services.operatorGroups, undefined, {
          DictionaryId: this.value.id,
          $limit: 1
        })
        if (typeof data?.total === 'number') {
          this.total = data.total
        }
      } catch (error) {
        this.total = undefined
      }
    },

    actionHandler(action, event) {
      event?.stopPropagation()
      this.$emit('action', action)
    }
  },

  render
}
